var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visivel ? _c('router-link', {
    staticClass: "painel-grupo-atalho d-block",
    attrs: {
      "to": {
        name: 'grupoEmpresaConsolidado'
      },
      "data-testid": "atalho-painel-consolidado"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-start justify-content-between"
  }, [_c('div', [_c('span', {
    staticClass: "painel-grupo-atalho__tag"
  }, [_vm._v("Visão multiempresa")]), _c('strong', {
    staticClass: "painel-grupo-atalho__titulo d-block mt-2"
  }, [_vm._v(" Painel consolidado ")]), _c('small', {
    staticClass: "painel-grupo-atalho__texto d-block mt-1"
  }, [_vm._v(" Vendas, financeiro e saldos bancários do grupo. ")])]), _c('span', {
    staticClass: "painel-grupo-atalho__seta"
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };